import { CircleDollarSign, Database, HardDrive, Mail, Server } from "lucide-react";
import { Status } from "../components/Status";

export function CommercePage() {
  return <section className="page">
    <header className="page-head"><div><h1>订单结算</h1><p>第三方平台订单、达人归因与权益发放</p></div><Status tone="muted">暂未启用</Status></header>
    <div className="pending-surface"><CircleDollarSign size={24} /><div><strong>等待卡发前端支付入口</strong><p>支付流程和订单字段确认后再接入平台订单、退款、佣金和权益核销。</p></div></div>
  </section>;
}

export function SystemPage() {
  return <section className="page">
    <header className="page-head"><div><h1>系统状态</h1><p>本地开发配置与后续香港环境</p></div><Status tone="warning">等待服务器</Status></header>
    <div className="system-list">
      <article><Server size={19} /><div><strong>API 服务</strong><small>本地 `127.0.0.1:8787`</small></div><Status tone="success">已配置</Status></article>
      <article><Database size={19} /><div><strong>PostgreSQL</strong><small>Docker `127.0.0.1:5433`</small></div><Status tone="warning">等待 Docker</Status></article>
      <article><HardDrive size={19} /><div><strong>安装包</strong><small>第三方网盘链接，不经过控制服务器</small></div><Status tone="success">策略确定</Status></article>
      <article><Mail size={19} /><div><strong>告警邮箱</strong><small>vipaso@qq.com</small></div><Status tone="success">已配置</Status></article>
    </div>
  </section>;
}
